import CartNavIcon from '@/assets/images/nav-cart.svg';
import CartNavIconLatino from '@/assets/images/nav-cart-latino.svg';
import IconWithFloatingContent from '../../EnkiDummyUI/IconWithFloatingContent';
import { ReactNode, useState } from 'react';
import { isLatinoChannel } from '@/utils/common/latino-app';

interface CartIconProps {
  altText: string;
  onClick?: () => void;
  counterNode?: ReactNode;
  dataTestId?: string;
}

const CartIcon: React.FC<CartIconProps> = ({ onClick, altText, counterNode, dataTestId }) => {
  const [showItemsCountBadge, setShowItemsCountBadge] = useState<boolean>(false);

  const isLatino = isLatinoChannel();

  const cartCount = () => {
    // TODO: handle rewards UI
    return null;
  };

  return (
    <IconWithFloatingContent
      icon={<img className="w-[24px] h-[24px]" src={isLatino ? CartNavIconLatino : CartNavIcon} alt={altText} />}
      floatingContent={showItemsCountBadge ? cartCount() : null}
      onClick={onClick}
      counterNode={counterNode}
      dataTestId={dataTestId}
    />
  );
};

export default CartIcon;
